import en from './en.json';
import nl from './nl.json';
import nlBE from './nl-be.json';
import fr from './fr.json';

const messages: any = {
    'en': en,
    'nl': nl,
    'nl-BE': nlBE,
    'fr': fr,
    'de': en // fallback to English as we don't support German yet, user could set their account to German trough the App)
};

export default messages;